var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavoritesLabelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v30.84a2 2 0 01-1.008 1.736l-12 6.857a2 2 0 01-1.984 0l-12-6.857A2 2 0 010 30.839V0z",
    fill: "#B81D7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.84V30l13.008 7.433a2 2 0 001.984 0L28 30v.84a2 2 0 01-1.008 1.736l-12 6.857a2 2 0 01-1.984 0l-12-6.857A2 2 0 010 30.839z",
    fill: "#fff",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 29l8.426-8.616c2.099-2.146 2.099-5.624 0-7.77a5.25 5.25 0 00-3.8-1.614 5.31 5.31 0 00-3.814 1.614l-.827.845-.828-.845A5.25 5.25 0 009.358 11a5.191 5.191 0 00-3.784 1.614c-2.099 2.146-2.099 5.624 0 7.77L14 29zm3-9l-3-3-3 3 3 3 3-3z",
    fill: "#fff"
  })));
}

export default SvgFavoritesLabelIcon;